// extracted by css-extract-rspack-plugin
export default {"cls1":"SmallAccountMenuButton-cls1_EnW","cls2":"SmallAccountMenuButton-cls2_NPf SmallAccountMenuButton-cls1_EnW"};